import { LaundryMachineOption, LaundryTypeOption, PaymentOption } from "../../types/laundry.types";

export enum PAGES {
  START_PAGE = 0,
  CHOOSE_LAUNDRY_TYPE = 1,
  CHOOSE_LAUNDRY_MACHINE = 2,
  LAUNDRY_PAYMENT = 3,
  LAUNDRY_PAYMENT_LOADING = 4,
  CHOOSE_TAX = 5,
  SEND_RECEIPT = 6,
  LAUNDRY_PAYMENT_SUCCESS = 7,
  LAUNDRY_PAYMENT_ERROR = 8,
  LAUNDRY_ACTIVATION_ERROR = 9,
}

export enum PAYMENT_TYPES {
  CARD_DEBIT = "debito",
  CARD_CREDIT = "credito"
}

export interface LaundryStoreInteraction {
  currPage: PAGES;
  selectedLaundryType: LaundryTypeOption;
  selectedPayment: PaymentOption;
  errorMsg: string;
  paymentId: string;
  cieloTransactionId: string;
  finalPrice: number;
  selectedLaundryMachine: LaundryMachineOption;
  taxId?: string;
}

export interface TotemLaundryStoreState extends LaundryStoreInteraction {
  laundryTypeOptions: LaundryTypeOption[];
  laundryMachineOptions: LaundryMachineOption[];
  totemId: string;
  terminalId: string;
}
